module.exports = __webpack_public_path__ + "img/right-arrow-grey.34430d40.png";